import React, { useCallback } from 'react';
import { Box, Chip } from '@mui/material';

const ResultsTableSnapshotChips = ({ snapshotContext }) => {
  const describeCapture = useCallback((capture) => {
    if (!capture) return '';
    const label = capture.programName || 'Program';
    if (!capture.capturedAt) return `${label}: unknown`;
    const parsed = new Date(capture.capturedAt);
    if (Number.isNaN(parsed.getTime())) return `${label}: ${capture.capturedAt}`;
    return `${label}: ${parsed.toLocaleString()}`;
  }, []);

  if (!snapshotContext) return null;

  return (
    <Box sx={{ mb: 1, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
      <Chip label={`Snapshot: ${snapshotContext.requested}`} color="info" size="small" />
      {Array.isArray(snapshotContext.captures)
        ? snapshotContext.captures.map((item, index) => (
            <Chip
              key={`${item.programName || 'program'}-${index}`}
              label={describeCapture(item)}
              size="small"
              variant="outlined"
            />
          ))
        : null}
    </Box>
  );
};

export default ResultsTableSnapshotChips;
